import styles from './SearchForm.module.scss'
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import cn from 'classnames'
import { useRouter } from 'next/router'
import { useRef } from 'react'
import Badge from '@/components/Badge'

function SearchForm({
  currentLocation = false,
  iconRight = false,
  placeholder = 'Zoek binnen',
  setLoading,
  iconAsSubmitButton = false,
  queries = [],
  className,
  initialSubmit = false,
  type = {},
  ...props
}) {
  const router = useRouter()
  const inputRef = useRef()

  async function handleForm(event) {
    event.preventDefault()

    if (setLoading) setLoading(true)

    const form = event.currentTarget
    const formData = new FormData(form)

    const { query, type } = Object.fromEntries(formData.entries())
    const url = currentLocation ? new URL(document.location) : new URL('/zoeken', process.env.NEXT_PUBLIC_VERCEL_URL)
    const params = url.searchParams
    query && params.append('query', query)
    type && params.append('type', type)

    if (queries.length > 0 && !initialSubmit) {
      queries.forEach((query) => params.append('query', query))
    }

    router.push(url)
    inputRef.current.value = ''
  }

  return (
    <form
      className={cn(styles['root'], {
        [className]: className,
        [styles['root--icon-right']]: iconRight,
        [styles['shadow']]: !currentLocation,
      })}
      noValidate
      autoComplete="off"
      onSubmit={handleForm}
      {...props}
    >
      <button
        title="Zoeken"
        aria-label="Zoeken"
        type="submit"
      >
        <MagnifyingGlassIcon />
      </button>

      <input
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        name="query"
      />

      {type.key && type.value && (
        <>
          <input
            type="hidden"
            value={type.key}
            name="type"
          />

          <Badge className="!px-3">{type.value}</Badge>
        </>
      )}
    </form>
  )
}

export default SearchForm
